"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFitToWidth = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * A hook to measure the width of an element and set the width of another element to match.
 */
const useFitToWidth = ({
  toMeasure,
  targetToChangeRef,
  matchCondition,
  measurementNodeClassName,
  widthBuffer = 0
}) => {
  const measurementRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    var _a, _b, _c;
    if (!matchCondition) return;
    if (measurementRef.current && targetToChangeRef.current) {
      if (toMeasure) {
        const width = Math.max(
        // Add a small buffer to prevent text from being too tight
        // 2px margin + 8px padding on each side = 20px buffer
        (((_a = measurementRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0) + widthBuffer);
        if ((_b = targetToChangeRef.current) === null || _b === void 0 ? void 0 : _b.style) {
          // eslint-disable-next-line no-param-reassign
          targetToChangeRef.current.style.width = `${width}px`;
        }
      } else if ((_c = targetToChangeRef.current) === null || _c === void 0 ? void 0 : _c.style) {
        // eslint-disable-next-line no-param-reassign
        targetToChangeRef.current.style.width = `${widthBuffer}px`;
      }
    }
  }, [toMeasure, matchCondition]);
  if (!matchCondition) return {
    measurementNode: null
  };
  return {
    measurementNode: (/*#__PURE__*/_react.default.createElement("div", {
      ref: measurementRef,
      "aria-hidden": "true",
      className: measurementNodeClassName
    }, toMeasure))
  };
};
exports.useFitToWidth = useFitToWidth;